import { useLocation, useParams, useHistory } from 'react-router-dom';
import React from 'react'


/**
 * Wraps a component with React Router v5 hook values.
 * @param {React.ComponentType} Component - Component to enhance with routing props.
 * @return {React.ComponentType} Wrapped component with `location`, `params`, and `history`.
 */
function withRouter(Component) {
  	/**
  	 * Injects router context into wrapped component props.
  	 * @param {Object} props - Props passed from parent.
  	 * @return {JSX.Element} Wrapped component with router props.
  	 */
  	function ComponentWithRouterProp(props) {
    	let location = useLocation();
    	// let navigate = useNavigate();
    	let params = useParams();
		let history = useHistory();
    	return (
      		<Component
        		{...props}
        		location={location}
        		params={params}
				history={history}
        		// navigate={navigate}
      		/>
    	);
  	}

	
  	return ComponentWithRouterProp;
}

export default withRouter;